import { atom } from "recoil";

// 미션 서비스 목록 (네이버, 리뷰 등)
export const missionServiceState = atom({
  key: "missionServiceState",
  default: [],
});

// 미션 액션 목록 (쇼핑 방문, 플레이스 방문 등)
export const missionActionState = atom({
  key: "missionActionState",
  default: [],
});

// 과거 주문 목록
export const pastOrderState = atom({
  key: "pastOrderState",
  default: [],
});

// 로딩 상태
export const addAdvertisementLoadingState = atom({
  key: "addAdvertisementLoadingState",
  default: false,
});

// 에러 상태
export const addAdvertisementErrorState = atom({
  key: "addAdvertisementErrorState",
  default: null,
});
